export { PatientCommunicationScreen } from './PatientCommunicationScreen';
